var React = require('react');

function Question (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 13C7.4 13 7 12.6 7 12C7 11.4 7.4 11 8 11C8.6 11 9 11.4 9 12C9 12.6 8.6 13 8 13ZM8.9999 9C8.9999 8.8 8.9999 8.7 9.4999 8.4C10.0999 8 10.9999 7.4 10.9999 6C10.9999 4.3 9.6999 3 7.9999 3C6.8999 3 5.8999 3.6 5.3999 4.5L4.8999 5.4L6.5999 6.4L7.0999 5.5C7.2999 5.2 7.5999 5 7.9999 5C8.5999 5 8.9999 5.4 8.9999 6C8.9999 6.3 8.8999 6.4 8.3999 6.7C7.7999 7.1 6.9999 7.7 6.9999 9V10H8.9999V9Z","fill":"#181818"}));
}

Question.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Question;

Question.default = Question;
